/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {TabModel} from '../../../../../../models'
import {SelectOption} from '../../../../../../models/utility.model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {TermsModel} from '../../models'
import {getTermsService} from '../../services/getTerms.service'
const TableTyC: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useHoteleria()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const {getCompanies, getClients, getSites} = useCentralServices()
  const [reception] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [autoService] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [busPark] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [app] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSites] = useState<SelectOption[]>([])

  useEffect(() => {
    getCompaniesFn()
    return () => {
      clearSearchValues()
    }
  }, [])

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    setSites(data)
  }

  const handlePaginationTerms = async () => {
    try {
      setLoading(true)
      // changeSearchValues({})
      const {data: response} = await getTermsService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEditItem = (item: TermsModel) => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'detail-tyc',
      },
      idToDelete: '',
      idToEdit: item.Id,
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetById = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const handleFilterClient = (e: any, name: string) => {
    let value = e.value
    getClientsFn(value)
    const {ClienteId, SiteId, CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }

  const handleFilterSite = (e: any, name: string) => {
    let value = e.value
    getSitesFn(value)
    const {SiteId, CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }

  const columns: Column<TermsModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetById}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'CompaniaId'}
            selecteable
            data={compani}
            onGetValueSelect={handleFilterClient}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
            onGetValueSelect={handleFilterSite}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={site} />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Recepción'
            name='ModRecepcion'
            data={reception}
            selecteable
          />
        ),
        accessor: 'ModRecepcion',
        Cell: ({...props}) => <div>{props.row.original.ModRecepcion ? 'SI' : 'NO'}</div>,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Autoservicio (totem)'
            name='ModAutoservicioTotem'
            data={autoService}
            selecteable
          />
        ),
        accessor: 'ModAutoservicioTotem',
        Cell: ({...props}) => <div>{props.row.original.ModAutoservicioTotem ? 'SI' : 'NO'}</div>,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Parqueo de buses'
            name='ModParqueoDeBuses'
            data={busPark}
            selecteable
          />
        ),
        accessor: 'ModParqueoDeBuses',
        Cell: ({...props}) => <div>{props.row.original.ModParqueoDeBuses ? 'SI' : 'NO'}</div>,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='App Huespedes'
            name='ModCheckInAppHuesped'
            data={app}
            selecteable
          />
        ),
        accessor: 'ModCheckInAppHuesped',
        Cell: ({...props}) => <div>{props.row.original.ModCheckInAppHuesped ? 'SI' : 'NO'}</div>,
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) =>
          isAllowed('EDITAR') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEditItem(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [compani, client, site, selectedOn],
  )

  useEffect(() => {
    handlePaginationTerms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      handlePaginationTerms()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])

  useEffect(() => {
    if (currentTabItem.deleted) {
      clearSelected()
      handlePaginationTerms()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    if (currentTabItem.updated) {
      clearSelected()
      handlePaginationTerms()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.updated])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      if (pagination.currentPage === 1) {
        handlePaginationTerms()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        handlePaginationTerms()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClient([])
      setSites([])
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableTyCWrapper = () => {
  const {isAllowed} = useHoteleria()
  return <KTableProvider>{isAllowed('LISTAR') && <TableTyC />}</KTableProvider>
}

export {TableTyCWrapper}
